import { Component, Input } from '@angular/core';
import { iUser } from '../user.interface';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { TableModule } from 'primeng/table';

@Component({
	selector: 'app-view-user',
	standalone: true,
	imports: [
		SharedModule,
		TableModule,
	],
	templateUrl: './view-user.component.html',
	styleUrl: './view-user.component.scss'
})
export class ViewUserComponent {
	@Input() user!: iUser;

	constructor(
		public nav: NavigationService,
	) { }

}
